export function CallableOnce(): MethodDecorator {
  const calledMethods = new WeakMap<object, Set<string | symbol>>()

  return function (
    target: object,
    propertyKey: string | symbol,
    descriptor: PropertyDescriptor,
  ): PropertyDescriptor {
    const originalMethod = descriptor.value

    descriptor.value = function (...args: unknown[]) {
      if (!calledMethods.has(this)) {
        calledMethods.set(this, new Set())
      }

      const calledSet = calledMethods.get(this)!

      if (calledSet.has(propertyKey)) {
        throw new Error(`Method "${String(propertyKey)}" was already called on this instance`)
      }

      calledSet.add(propertyKey)

      return originalMethod.apply(this, args)
    }

    return descriptor
  }
}
